export * from "./getDictPhrase";